import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: "Organice todo mi cuatrimestre en una tarde. Las plantillas de apuntes me ahorraron horas de idas y vueltas cada semana. Y lo mejor, aprobe 3 materias seguidas jajaja, saludos!",
  name: 'Martín G.',
  location: "Córdoba · Argentina",
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/2c2c0595-1eea-431f-a991-351bd2295f48.jpg'
}, {
  quote: "El protocolo anti-bloqueo me funciono notablemente. El tomo de manejo de ansiedad es el más útil para entender como rendir un final oral sin congelarse.",
  name: 'Valentina P.',
  location: "Rosario · Argentina",
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/7cf62f48-efdb-43df-a224-015d4d12f8b2.jpg'
}, {
  quote: "Mis notas no dejaron de mejorar. El planificador cuatrimestral vale absolutamente cada centavo. Pase de recursar a aprobar todo en un cuatrimestre. GRACIAS",
  name: 'Camila R.',
  location: "Buenos Aires · Argentina",
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/0b522287-cfe4-4ccf-9781-0c38d2e3d235.jpg'
}];
export function Testimonials() {
  return <section aria-label="Testimonios" className="bg-ink" data-id="element-171" data-mp="77s7jzaq0azt">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20 pt-[47px]" style={{
      paddingTop: "0px",
      paddingBottom: "20px",
      marginTop: "-15px",
      marginBottom: "-15px"
    }} data-id="element-172" data-mp="79bn1nojyi0j">
        
        <div className="mt-10 grid w-full grid-cols-1 gap-5 sm:mt-12 md:grid-cols-3 md:gap-6" data-id="element-173" data-mp="zxh86bjiq90w">
          {testimonials.map((t, i) => <motion.figure key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex flex-col rounded-2xl border border-white/10 bg-ink-2 p-5" style={{
          paddingBottom: "15px",
          marginTop: "0px",
          marginBottom: "0px"
        }} data-id="element-174" data-mp="14uzmkhgb1gga" data-mpi={i}>
              <figcaption className="flex items-center gap-3" data-id="element-175" data-mp="1xi0o3ch89zzp">
                <img src={t.img} alt={t.name} className="h-11 w-11 shrink-0 rounded-full object-cover ring-2 ring-gold/50" data-id="element-176" data-mp="1xhh65vrkvblo" />
                <div className="min-w-0" data-id="element-177" data-mp="1sh37337yfbzs">
                  <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5" data-id="element-178" data-mp="1ogj9xznds8dn">
                    <span className="text-sm font-bold text-white" data-id="element-179" data-mp="1jihpbaab4102">{t.name}</span>
                    <span className="flex gap-0.5 text-gold" data-id="element-180" data-mp="1ej4tw15ddllv">
                      {Array.from({
                    length: 5
                  }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" data-id="element-181" data-mp="19s69oqh9g3dc" data-mpi={k} />)}
                    </span>
                  </div>
                  <div className="text-xs text-white/50" data-id="element-182" data-mp="14tv5owdncn31">📍 {t.location}</div>
                </div>
              </figcaption>
              <blockquote className="mt-4 flex-1 border-t border-white/10 pt-4 text-[15px] leading-relaxed text-white/80" data-id="element-183" data-mp="10px48f0un06t">
                “{t.quote}”
              </blockquote>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}